/**
 * Модуль для работы с расписанием врачей на странице списка
 */

(function($) {
    'use strict';

    // Кэш для хранения данных расписания
    const scheduleCache = {};
    
    // Массив дней недели на русском
    const weekDays = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
    const weekDaysFull = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];
    const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];

    /**
     * Инициализация расписания для всех врачей
     */
    function initDoctorsSchedule() {
        $('.doctor-list-item').each(function() {
            const $doctorItem = $(this);
            const doctorId = $doctorItem.data('doctor-id');
            
            if (doctorId) {
                loadDoctorDays(doctorId, $doctorItem);
            }
        });
    }

    /**
     * Загрузка доступных дней для врача
     */
    function loadDoctorDays(doctorId, $doctorItem) {
        const $daysTrack = $doctorItem.find('.doctor-list-item__days-track');
        
        $.ajax({
            type: 'POST',
            url: '/api/booking/get-days',
            data: {
                'doctorId': doctorId,
                'html': false,
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function(response) {
                if (response.status === 'success' && response.data && response.data.length > 0) {
                    scheduleCache[doctorId] = {
                        days: response.data,
                        currentIndex: 0
                    };
                    renderDays(doctorId, $doctorItem);
                } else {
                    showNoDaysMessage($doctorItem);
                }
            },
            error: function(xhr, status, error) {
                showNoDaysMessage($doctorItem);
            }
        });
    }

    /**
     * Отображение сообщения об отсутствии доступных дней
     */
    function showNoDaysMessage($doctorItem) {
        const $daysTrack = $doctorItem.find('.doctor-list-item__days-track');
        $daysTrack.html('<div class="doctor-list-item__days-loading">Нет доступных дней для записи</div>');
        $doctorItem.find('.doctor-list-item__schedule-title').text('Расписание недоступно');
    }

    /**
     * Отрисовка дней
     */
    function renderDays(doctorId, $doctorItem) {
        const cache = scheduleCache[doctorId];
        if (!cache || !cache.days.length) return;

        const $daysTrack = $doctorItem.find('.doctor-list-item__days-track');
        const $prevBtn = $doctorItem.find('.doctor-list-item__days-prev');
        const $nextBtn = $doctorItem.find('.doctor-list-item__days-next');
        
        // Отрисовываем все дни
        let daysHtml = '';
        cache.days.forEach(function(dayData, index) {
            const date = parseDate(dayData.date);
            const weekDay = weekDays[date.getDay()];
            const dayNumber = dayData.day;
            const isActive = index === 0 ? 'active' : '';
            
            daysHtml += `
                <div class="doctor-list-item__day ${isActive}" data-date="${dayData.date}" data-index="${index}">
                    <span class="doctor-list-item__day-weekday">${weekDay}</span>
                    <span class="doctor-list-item__day-number">${dayNumber}</span>
                </div>
            `;
        });
        
        $daysTrack.html(daysHtml);
        
        // Обновляем состояние кнопок
        updateNavigationButtons($doctorItem, doctorId);
        
        // Загружаем слоты для первого дня
        if (cache.days[0]) {
            loadDoctorSlots(doctorId, cache.days[0].date, $doctorItem);
            updateScheduleTitle($doctorItem, cache.days[0].date);
        }
    }

    /**
     * Парсинг даты из формата dd.mm.yyyy
     */
    function parseDate(dateStr) {
        const parts = dateStr.split('.');
        return new Date(parts[2], parts[1] - 1, parts[0]);
    }

    /**
     * Обновление заголовка расписания
     */
    function updateScheduleTitle($doctorItem, dateStr) {
        const date = parseDate(dateStr);
        const weekDayFull = weekDaysFull[date.getDay()];
        const day = date.getDate();
        const month = months[date.getMonth()];
        
        const title = `Запись на ${weekDayFull.toLowerCase()}, ${day} ${month}`;
        $doctorItem.find('.doctor-list-item__schedule-title').text(title);
    }

    /**
     * Обновление состояния кнопок навигации
     */
    function updateNavigationButtons($doctorItem, doctorId) {
        const cache = scheduleCache[doctorId];
        if (!cache) return;

        const $prevBtn = $doctorItem.find('.doctor-list-item__days-prev');
        const $nextBtn = $doctorItem.find('.doctor-list-item__days-next');
        const $slider = $doctorItem.find('.doctor-list-item__days-slider');
        const $track = $doctorItem.find('.doctor-list-item__days-track');
        
        // Рассчитываем количество видимых элементов
        const sliderWidth = $slider.width();
        const dayWidth = 68; // 60px ширина + 8px gap
        const visibleCount = Math.floor(sliderWidth / dayWidth);
        const totalDays = cache.days.length;
        
        // Обновляем кнопки
        $prevBtn.prop('disabled', cache.currentIndex === 0);
        $nextBtn.prop('disabled', cache.currentIndex + visibleCount >= totalDays);
        
        // Применяем трансформацию
        const offset = -cache.currentIndex * dayWidth;
        $track.css('transform', `translateX(${offset}px)`);
    }

    /**
     * Загрузка временных слотов для выбранного дня
     */
    function loadDoctorSlots(doctorId, date, $doctorItem) {
        const $slotsContent = $doctorItem.find('.doctor-list-item__time-slots-content');
        $slotsContent.html('<div class="doctor-list-item__time-notice">Загрузка слотов...</div>');
        
        $.ajax({
            type: 'POST',
            url: '/api/booking/get-slots',
            data: {
                'doctorId': doctorId,
                'date': date,
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function(html) {
                const $html = $(html);
                const $slots = $html.filter('.table__cell');
                
                if ($slots.length > 0) {
                    let slotsHtml = '';
                    $slots.each(function() {
                        const time = $(this).data('time');
                        slotsHtml += `<div class="doctor-list-item__time-slot" data-time="${time}" data-date="${date}">${time}</div>`;
                    });
                    $slotsContent.html(slotsHtml);
                } else {
                    $slotsContent.html('<span class="doctor-list-item__time-notice">Нет доступных слотов для записи.</span>');
                }
            },
            error: function() {
                $slotsContent.html('<span class="doctor-list-item__time-notice">Ошибка загрузки слотов.</span>');
            }
        });
    }

    /**
     * Обработчик клика по дню
     */
    $(document).on('click', '.doctor-list-item__day', function() {
        const $day = $(this);
        const $doctorItem = $day.closest('.doctor-list-item');
        const doctorId = $doctorItem.data('doctor-id');
        const date = $day.data('date');
        const index = $day.data('index');
        
        // Убираем активный класс со всех дней этого врача
        $doctorItem.find('.doctor-list-item__day').removeClass('active');
        $day.addClass('active');
        
        // Загружаем слоты
        loadDoctorSlots(doctorId, date, $doctorItem);
        updateScheduleTitle($doctorItem, date);
    });

    /**
     * Обработчик клика по временному слоту
     */
    $(document).on('click', '.doctor-list-item__time-slot', function() {
        const $slot = $(this);
        const $doctorItem = $slot.closest('.doctor-list-item');
        const doctorId = $doctorItem.data('doctor-id');
        const time = $slot.data('time');
        const date = $slot.data('date');
        
        // Убираем активный класс со всех слотов этого врача
        $doctorItem.find('.doctor-list-item__time-slot').removeClass('active');
        $slot.addClass('active');
        
        // Сохраняем выбранные дату и время в localStorage
        localStorage.setItem('selectedDoctorId', doctorId);
        localStorage.setItem('selectedDate', date);
        localStorage.setItem('selectedTime', time);
        
        // Получаем slug врача из ссылки "О враче"
        const doctorSlug = $doctorItem.find('.doctor-list-item__btn-about').attr('href').split('/').pop();
        
        // Получаем информацию о враче для popup
        const doctorName = $doctorItem.find('.doctor-list-item__name a').text().trim();
        const doctorAbout = $doctorItem.find('.doctor-list-item__specialization').text().trim();
        
        // Форматируем дату и время для отображения
        const formattedDateTime = formatDateTime(date, time);
        
        // Заполняем popup информацией
        $('#appointment-confirmation .popup__doctor-name').text(doctorName);
        $('#appointment-confirmation .popup__doctor-about').text(doctorAbout);
        $('#appointment-confirmation .popup__appointment-time').text(formattedDateTime);
        
        // Сохраняем doctorSlug и packageSlug для перехода после подтверждения
        $('#confirm-appointment-btn').data('doctor-slug', doctorSlug);
        
        // Проверяем, есть ли информация о пакете на странице
        const packageSlug = $doctorItem.data('package-slug') || window.currentPackageSlug;
        $('#confirm-appointment-btn').data('package-slug', packageSlug);
        
        // Показываем popup
        if (typeof _openPopup === 'function') {
            _openPopup('appointment-confirmation');
        } else {
            // Fallback, если функция не доступна
            const $popup = $('#appointment-confirmation');
            $popup.css({
                'visibility': 'visible',
                'opacity': '1'
            });
            $('body').addClass('_lock');
            $popup.find('.overlay').show();
        }
    });
    
    /**
     * Форматирование даты и времени для отображения
     */
    function formatDateTime(dateStr, time) {
        const date = parseDate(dateStr);
        const weekDayFull = weekDaysFull[date.getDay()];
        const day = date.getDate();
        const month = months[date.getMonth()];
        
        return `${weekDayFull}, ${day} ${month}, ${time}`;
    }
    
    /**
     * Обработчик клика на кнопку подтверждения в popup
     */
    $(document).on('click', '#confirm-appointment-btn', function() {
        const doctorSlug = $(this).data('doctor-slug');
        const packageSlug = $(this).data('package-slug');
        
        // Закрываем popup
        if (typeof _closePopup === 'function') {
            _closePopup('appointment-confirmation');
        } else {
            // Fallback
            const $popup = $('#appointment-confirmation');
            $popup.css({
                'visibility': 'hidden',
                'opacity': '0'
            });
            $('body').removeClass('_lock');
            $popup.find('.overlay').hide();
        }
        
        // Переходим на страницу записи врача
        if (doctorSlug) {
            if (packageSlug) {
                // Если есть пакет, переходим сразу к расписанию с выбранным временем
                const selectedDate = localStorage.getItem('selectedDate');
                const selectedTime = localStorage.getItem('selectedTime');
                let url = `/doctor/${doctorSlug}/schedule/${packageSlug}`;
                
                if (selectedDate && selectedTime) {
                    url += `?date=${encodeURIComponent(selectedDate)}&time=${encodeURIComponent(selectedTime)}`;
                }
                
                window.location.href = url;
            } else {
                // Обычный переход на страницу выбора продукта
                window.location.href = `/doctors/${doctorSlug}/appointment`;
            }
        }
    });

    /**
     * Навигация по дням - кнопка "Назад"
     */
    $(document).on('click', '.doctor-list-item__days-prev', function() {
        const $btn = $(this);
        if ($btn.prop('disabled')) return;
        
        const $doctorItem = $btn.closest('.doctor-list-item');
        const doctorId = $doctorItem.data('doctor-id');
        const cache = scheduleCache[doctorId];
        
        if (cache && cache.currentIndex > 0) {
            cache.currentIndex--;
            updateNavigationButtons($doctorItem, doctorId);
        }
    });

    /**
     * Навигация по дням - кнопка "Вперед"
     */
    $(document).on('click', '.doctor-list-item__days-next', function() {
        const $btn = $(this);
        if ($btn.prop('disabled')) return;
        
        const $doctorItem = $btn.closest('.doctor-list-item');
        const doctorId = $doctorItem.data('doctor-id');
        const cache = scheduleCache[doctorId];
        
        if (!cache) return;
        
        const $slider = $doctorItem.find('.doctor-list-item__days-slider');
        const sliderWidth = $slider.width();
        const dayWidth = 68;
        const visibleCount = Math.floor(sliderWidth / dayWidth);
        
        if (cache.currentIndex + visibleCount < cache.days.length) {
            cache.currentIndex++;
            updateNavigationButtons($doctorItem, doctorId);
        }
    });

    // Инициализация при загрузке страницы
    $(document).ready(function() {
        // Проверяем, находимся ли мы на странице списка врачей
        if ($('.doctors__list').length > 0) {
            initDoctorsSchedule();
        }
    });

})(window.jQuery || window.$ || jQuery);

